import Swiper from '../vendors/swiper.min.js';

export default class Sliders {
  static gallery() {
    return new Swiper('.introduction-slider__inner', {
      loop: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: '.introduction-slider__pagination',
        type: 'bullets',
      },
    });
  }

  static figures() {
    return new Swiper('.figures-slider', {
      loop: true,
      autoplay: {
        delay: 3000,
      },
      centeredSlides: true,
      slidesPerView: 5,
      pagination: {
        el: '.figures-slider__pagination',
        type: 'bullets',
      },
      breakpoints: {
        767: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 1,
        }
      },
    });
  }
}
